import { message } from 'iglooform';
import { dropRight, findLastIndex } from 'lodash';
import moment from 'moment';

// {relationship_1: xxx, relationship_2: xxx} => [{relationship:xxx},{relationship:xxx}]
export const transformAdditionalData = (insuredObj: any) => {
  const obj: Record<string, { [key: string]: any }> = {};
  Object.keys(insuredObj).forEach((key) => {
    const keyArr = key.split('_');
    const flag = keyArr.at(-1) as string;
    const realKey = dropRight(keyArr).join('_');
    const val = insuredObj[key];
    if (obj[flag]) {
      obj[flag][realKey] = val;
    } else {
      obj[flag] = { [realKey]: val };
    }
  });
  return Object.values(obj).map((val) => val);
};

const ageNotRight = (
  birth: any,
  minAge: number,
  maxAge: number,
  policyStartTime: number,
) => {
  const now = moment(policyStartTime).startOf('day');
  const age = now.diff(moment(birth).startOf('day'), 'years');
  return age < minAge || age > maxAge;
};

const ageBetweenMinAndMax = (
  birth: any,
  minAge: number,
  maxAge: number,
  policyStartTime: number,
) => {
  const now = moment(policyStartTime).startOf('day');
  const age = now.diff(moment(birth).startOf('day'), 'years');
  return age >= minAge && age <= maxAge;
};

const insuredAgeNotRight = (
  arr: any[],
  minAge: number,
  maxAge: number,
  policyStartTime: number,
) => {
  return arr.some((item) => {
    return ageNotRight(item.birth_date, minAge, maxAge, policyStartTime);
  });
};

const insuredNotWithParent = (
  arr: any[],
  minAge: number,
  maxAge: number,
  policyStartTime: number,
) => {
  if (
    arr.length === 1 &&
    ageBetweenMinAndMax(arr[0].birth_date, minAge, maxAge, policyStartTime)
  ) {
    return true;
  }
  if (
    arr.some(
      (item) =>
        item.relationship === 'child' &&
        ageBetweenMinAndMax(item.birth_date, minAge, maxAge, policyStartTime),
    ) &&
    !arr.some((item) => ['self', 'wife_husband'].includes(item.relationship))
  ) {
    return true;
  }
  if (
    arr.some(
      (item) =>
        item.relationship === 'brother_sister' &&
        ageBetweenMinAndMax(item.birth_date, minAge, maxAge, policyStartTime),
    ) &&
    !arr.some((item) => ['parent'].includes(item.relationship))
  ) {
    return true;
  }
  return false;
};

// bsh-hc 验证
export const validateFail = (
  arr: any[],
  policyInfo: any,
  formatMessage: any,
) => {
  const { policy_start_date } = policyInfo;

  if (arr.length === 0) {
    message.error(formatMessage({ id: 'Insured list can not be empty' }));
    return true;
  }
  if (
    arr.findIndex((item) => item.relationship === 'self') !==
    findLastIndex(arr, (item) => item.relationship === 'self')
  ) {
    message.error(
      formatMessage({
        id: 'Sorry, you can only add one "self" in the insured list',
      }),
    );
    return true;
  }
  if (insuredAgeNotRight(arr, 5, 65, policy_start_date)) {
    message.error(
      formatMessage({
        id: 'The age of the insured person should be from 5 to 65 years old',
      }),
    );
    return true;
  }
  if (insuredNotWithParent(arr, 5, 17, policy_start_date)) {
    message.error(
      formatMessage({
        id: 'Insured from 05 to 17 years old must take policy with their parents',
      }),
    );
    return true;
  }
  return false;
};

// bsh-pa 验证
export const validatePaFail = (
  arr: any[],
  policyInfo: any,
  formatMessage: any,
) => {
  const { policy_start_date } = policyInfo;

  if (arr.length === 0) {
    message.error(formatMessage({ id: 'Insured list can not be empty' }));
    return true;
  }
  if (
    arr.findIndex((item) => item.relationship === 'self') !==
    findLastIndex(arr, (item) => item.relationship === 'self')
  ) {
    message.error(
      formatMessage({
        id: 'Sorry, you can only add one "self" in the insured list',
      }),
    );
    return true;
  }
  if (insuredAgeNotRight(arr, 1, 70, policy_start_date)) {
    message.error(
      formatMessage({
        id: 'The age of the insured person should be from 1 to 70 years old',
      }),
    );
    return true;
  }
  if (insuredNotWithParent(arr, 1, 17, policy_start_date)) {
    message.error(
      formatMessage({
        id: 'Insured from 01 to 17 years old must take policy with their parents',
      }),
    );
    return true;
  }
  return false;
};
